import { useLocation, useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InputAdornment from "@mui/material/InputAdornment";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import dayjs from "dayjs";
import { useState, useEffect } from "react";

export default function DateRangeParamPicker() {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);

  // Read from URL or set defaults
  const startParam = searchParams.get("start_date");
  const endParam = searchParams.get("end_date");

  const defaultStart = startParam
    ? dayjs(startParam)
    : dayjs().subtract(30, "day");
  const defaultEnd = endParam ? dayjs(endParam) : dayjs();

  const [selectedRange, setSelectedRange] = useState<[any, any]>([
    defaultStart,
    defaultEnd,
  ]);

  // If missing, write defaults to URL
  useEffect(() => {
    if (!startParam || !endParam) {
      const updatedParams = new URLSearchParams(location.search);
      updatedParams.set("start_date", defaultStart.format("YYYY-MM-DD"));
      updatedParams.set("end_date", defaultEnd.format("YYYY-MM-DD"));
      navigate(`${location.pathname}?${updatedParams.toString()}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDateChange = (newValue: [any, any]) => {
    const [startDate, endDate] = newValue || [];
    if (!startDate || !endDate) return;

    setSelectedRange(newValue);

    const updatedParams = new URLSearchParams(location.search);
    updatedParams.set("start_date", startDate.format("YYYY-MM-DD"));
    updatedParams.set("end_date", endDate.format("YYYY-MM-DD"));

    navigate(`${location.pathname}?${updatedParams.toString()}`, {
      replace: true,
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        slots={{ field: SingleInputDateRangeField }}
        value={selectedRange}
        onChange={handleDateChange}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            color: "secondary",
            inputProps: { readOnly: true },
            sx: {
              "& .MuiInputBase-input": { pointerEvents: "none" },
            },
            placeholder: "Select Date Period",
            InputLabelProps: { shrink: true },
            label: "Date Period",
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  <CalendarTodayIcon
                    fontSize="small"
                    sx={{ cursor: "pointer" }}
                  />
                </InputAdornment>
              ),
            },
          },
        }}
        format="DD/MM/YYYY"
      />
    </LocalizationProvider>
  );
}
